import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import "firebase/performance";
import 'firebase/messaging';
import "firebase/analytics";

import { firebaseConfig } from '../constants/defaultValues';

let auth = null;
let database = null;
let perf = null;
let message = null;

const app=firebase.initializeApp(firebaseConfig);

if (firebase.messaging.isSupported()) {

	auth = firebase.auth();
	database = firebase.database();
	perf = firebase.performance();
	message=firebase.messaging();

}
else {
	console.log('browser not supported!!!')
}

// Initialize Analytics and get a reference to the service
const analytics = firebase.analytics(app);

export { auth, database, perf,  message, analytics};
